import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsPhotoStationPhotoInfo } from "./wsPhotoStationPhotoInfo";
import { wsPhotoStationPhotoUploadInfoParm } from "./wsPhotoStationPhotoUploadInfoParm";
import { wsPhotoStationSignatureUploadInfoParm } from "./wsPhotoStationSignatureUploadInfoParm";
import { wsPhotoStationDataInfoParm } from "./wsPhotoStationDataInfoParm";
import { wsPrintSchoolOptionsInfoParm } from "./wsPrintSchoolOptionsInfoParm";
import { wsPhotoStationValidateReleaseInfoParm } from "./wsPhotoStationValidateReleaseInfoParm";
import { wsPhotoStationPrintParm } from "./wsPhotoStationPrintParm";
import { wsPhotoAIUploadInfo } from "./wsPhotoAIUploadInfo";
import { wsAiColorPickerParmInfo, wsAiColorPickerInfo, wsAiColorPickerDefaultAIColorParmInfo} from "./wsPhotoAIColorPresetInfo";

@Injectable()
export class DataService_photostation {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationPhotoGet
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationPhotoGet(parms: wsPhotoStationPhotoInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoStationPhotoGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationPhotoUpload
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationPhotoUpload(parms: wsPhotoStationPhotoUploadInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoStationPhotoUpload";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationSignatureUpload
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationSignatureUpload(parms: wsPhotoStationSignatureUploadInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoStationSignatureUpload";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	
	
	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationDataGet(parms: wsPhotoStationDataInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoStationDataGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintSchoolOptionsGet
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintSchoolOptionsGet(parms: wsPrintSchoolOptionsInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrintSchoolOptionsGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationValidateRelease
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationValidateRelease(parms: wsPhotoStationValidateReleaseInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoStationValidateRelease";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationPrintCard
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationPrintCard(parms: wsPhotoStationPrintParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoStationPrintCard";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoAIRemoveBackground
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoAIRemoveBackground(parm: wsPhotoAIUploadInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoAIRemoveBackground";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoAICreatePortrait
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoAICreatePortrait(parm: wsPhotoAIUploadInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/PhotoAICreatePortrait";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AIColorPickerGetDefaultAIColor
	//
	//-----------------------------------------------------------------------------------------------------
	AIColorPickerGetDefaultAIColor(parm: wsAiColorPickerDefaultAIColorParmInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/AIColorPickerGetDefaultAIColor";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AIColorPickerGet
	//
	//-----------------------------------------------------------------------------------------------------
	AIColorPickerGet(parm: wsAiColorPickerParmInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/AIColorPickerGet";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AIColorPickerUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	AIColorPickerUpdate(parm: wsAiColorPickerInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/AIColorPickerUpdate";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	

}
